<template>
  <div class="top">
    <img :src="img"
         alt="">
    <ul>
      <li class="li1">
        <a href="#/home">
          {{text}}
        </a>
      </li>
      <li class="li2">
        <a href="#/product">
          {{text1}}
        </a>
      </li>
      <li class="li3">
        <a href="#/dynamic">
          {{text2}}
        </a>
      </li>
      <li class="li4">
        <a href="#/honor">
          {{text3}}
        </a>
      </li>
      <li class="li5">
        <a href="#/aboutus">
          {{text4}}
        </a>
      </li>
      <li class="li6">
        <a href="#/download">
          {{text5}}
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  data () {
    return {
      img: require('../assets/componylogo.png'),

      text: '首页',
      text1: '产品与服务',
      text2: '企业动态',
      text3: '资质荣誉',
      text4: '关于我们',
      text5: '下载'
    }
  }
}
</script>

<style scoped lang="less">
.top {
  height: 10%;
  position: relative;
  z-index: 5;
  img {
    object-fit: contain;
    display: block;
    width: 10%;
    height: 100%;
    padding: 10px 20px;
    margin-left: 8%;
  }
  ul {
    float: right;
    margin-top: -50px;
    font-size: 14px;
    .li1 {
      list-style-type: none;
      float: left;
      text-decoration: none;
      text-align: center;
      line-height: 30px;
      a {
        color: #757575;
        text-decoration: none;
      }
    }
    .li2 {
      list-style-type: none;
      float: left;
      text-decoration: none;
      text-align: center;
      line-height: 30px;
      a {
        color: #757575;
        text-decoration: none;
      }
    }
    .li3 {
      list-style-type: none;
      float: left;
      text-decoration: none;
      text-align: center;
      line-height: 30px;
      a {
        color: #757575;
        text-decoration: none;
      }
    }
    .li4 {
      list-style-type: none;
      float: left;
      text-decoration: none;
      text-align: center;
      line-height: 30px;
      a {
        color: #757575;
        text-decoration: none;
      }
    }
    .li5 {
      list-style-type: none;
      float: left;
      text-decoration: none;
      text-align: center;
      line-height: 30px;
      a {
        color: #757575;
        text-decoration: none;
      }
    }
    .li6 {
      list-style-type: none;
      float: left;
      text-decoration: none;
      text-align: center;
      line-height: 30px;
      a {
        color: #757575;
        text-decoration: none;
      }
    }
  }
}

@media only screen and (min-width: 1781px) {
  .top {
    ul {
      margin-right: 12%;

      .li1 {
        margin: 0 80px;
        a {
          font-size: 14px;
        }
      }
      .li2 {
        margin: 0 80px;
        a {
          font-size: 14px;
        }
      }
      .li3 {
        margin: 0 80px;
        a {
          font-size: 14px;
        }
      }
      .li4 {
        margin: 0 80px;
        a {
          font-size: 14px;
        }
      }
      .li5 {
        margin: 0 80px;
        a {
          font-size: 14px;
        }
      }
      .li6 {
        margin: 0 80px;
        a {
          font-size: 14px;
        }
      }
    }
  }
}
@media only screen and (min-width: 1601px) and (max-width: 1780px) {
  .top {
    ul {
      margin-right: 8%;
      .li1 {
        margin: 0 80px;
        a {
          font-size: 14px;
        }
      }
      .li2 {
        margin: 0 80px;
        a {
          font-size: 14px;
        }
      }
      .li3 {
        margin: 0 80px;
        a {
          font-size: 14px;
        }
      }
      .li4 {
        margin: 0 80px;
        a {
          font-size: 14px;
        }
      }
      .li5 {
        margin: 0 80px;
        a {
          font-size: 14px;
        }
      }
      .li6 {
        margin: 0 80px;
        a {
          font-size: 14px;
        }
      }
    }
  }
}
@media only screen and (min-width: 1421px) and (max-width: 1600px) {
  .top {
    ul {
      margin-right: 8%;
      .li1 {
        margin: 0 60px;
        a {
          font-size: 14px;
        }
      }
      .li2 {
        margin: 0 60px;
        a {
          font-size: 14px;
        }
      }
      .li3 {
        margin: 0 60px;
        a {
          font-size: 14px;
        }
      }
      .li4 {
        margin: 0 60px;
        a {
          font-size: 14px;
        }
      }
      .li5 {
        margin: 0 60px;
        a {
          font-size: 14px;
        }
      }
      .li6 {
        margin: 0 60px;
        a {
          font-size: 14px;
        }
      }
    }
  }
}
@media only screen and (min-width: 1200px) and (max-width: 1420px) {
  .top {
    ul {
      margin-right: 10%;
      .li1 {
        margin: 0 50px;
        a {
          font-size: 10px;
        }
      }
      .li2 {
        margin: 0 50px;
        a {
          font-size: 10px;
        }
      }
      .li3 {
        margin: 0 50px;
        a {
          font-size: 10px;
        }
      }
      .li4 {
        margin: 0 50px;
        a {
          font-size: 10px;
        }
      }
      .li5 {
        margin: 0 50px;
        a {
          font-size: 10px;
        }
      }
      .li6 {
        margin: 0 50px;
        a {
          font-size: 10px;
        }
      }
    }
  }
}
@media only screen and (max-width: 1200px) {
  .top {
    ul {
      margin-right: 8%;
      .li1 {
        margin: 0 50px;
        a {
          font-size: 10px;
        }
      }
      .li2 {
        margin: 0 50px;
        a {
          font-size: 10px;
        }
      }
      .li3 {
        margin: 0 50px;
        a {
          font-size: 10px;
        }
      }
      .li4 {
        margin: 0 50px;
        a {
          font-size: 10px;
        }
      }
      .li5 {
        margin: 0 50px;
        a {
          font-size: 10px;
        }
      }
      .li6 {
        margin: 0 50px;
        a {
          font-size: 10px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/header.vue